import React from "react";
import {
  // workImgOne,
  workImgTwo,
  workImgThree,
  workImgFour,
  workImgFive,
  workImgSix,
  // workImgSeven,
  workImgEight,
} from "../../assets";
import Title from "../home/Title";
import ProjectsCard from "./ProjectsCard";

const ProductUlElements = {
  NxtTrends: [
    "Implemented pages for Login, Products, and Product details with React Router, React components, and form inputs.",
    "Secured user data with JWT tokens, REST API calls, and local storage.",
    "Technologies used:  React JS, JS, CSS, Bootstrap, Routing, REST API Calls, Local Storage, JWT Token, Authorization, Authenticatio",
    "Username:-rahul, Password:- rahul@2021",
  ],
  FoodMunch: [
    "Designed page using following HTML structure elements like li, header, article, footer elements and different bootstrap components to show different sections in the website and different bootstrap classes for responsiveness through mobile-first approach",
    "Implemented product youtube videos by using bootstrap embed and model components.",
    "Technologies used:  HTML, CSS, Bootstrap",
  ],
  TodoApplication: [
    "Displayed list of todos with HTML list elements, styled todo list using CSS, Bootstrap",
    "Implemented todo crud operations by using JavaScript event listeners and updated UI dynamically by using JavaScript DOM operations.",
    "Used Arrays, Objects and their methods during todolist CRUD Operations, Persisted todo list state on page reloads using local storage methods.",
    "Technologies used:  HTML, CSS, JS, Bootstrap",
  ],
  WikiPeddia: [
    "Streamlined search results with HTML list elements, styled for a modern and user-friendly interface using CSS, Bootstrap and responsive design.",
    "Effortlessly access information with asynchronous fetch GET HTTP API calls and the option to open the desired result in a new tab for further exploration.",
    "Technologies used:  HTML, CSS, JS, REST API Calls, Bootstrap",
  ],
  MCAConnectHub: [
    "Notices and Updates: Access to important information like exam timetables, assignments, and practicals.",
    "Results with Grade Points: Display of student results including grade points, which are not provided by the official OU site.",
    "Assignments & Material PDFs: Downloadable assignment and material PDFs for easy study reference.",
    "Important Exam Questions: A curated list of important exam questions to help students prepare effectively.",
    "Hall Ticket Number Finder: A dedicated section to help students retrieve their hall ticket numbers.",
    "Pass/Fail Data Analysis: Displays semester-wise pass and fail student data.",
    "NASA APOD Integration: An additional feature showcasing NASA's Astronomy Picture of the Day (APOD).",
    "Traffic Monitoring: Integrated Google Analytics for tracking website traffic and user engagement.",
    "Technologies used: React.js, HTML, CSS, Google Analytics, API integration (NASA APOD).",
  ],
  JobbyApp: [
    "Authentication System: Handles login validation, redirection, and access control based on authentication status.",
    "Login Route: Implements validation with proper error messages for incorrect credentials. Redirects authenticated users to the Home page and unauthenticated users to the Login page when accessing protected routes. // Prevents authenticated users from accessing the Login page and redirects them to the Home page instead.",
    "Home Route: Authenticated users can access the Home route and navigate to the Jobs page via the Find Jobs button.",
    "Jobs Route: Fetches profile data via an HTTP GET request to the Profile API. // Displays a loading state while data is fetched and handles failures with a retry mechanism. // Fetches job data using various query parameters such as employment type, salary range, and search input. The filters update the results dynamically based on user inputs. // Handles empty job lists gracefully by showing a No Jobs view when applicable. // Implements a loader for data fetching and a Failure View when HTTP requests are unsuccessful, with retry options. // Handles multiple filters simultaneously and dynamically updates the job list based on selected criteria. // Search functionality allows users to input search terms, making filtered job queries.",
    "Job Item Details Route: Fetches detailed job information along with a list of similar jobs using an HTTP GET request. // Includes a loader while data is fetched and a retry mechanism for failed requests. // Provides the option to open the company website in a new tab upon clicking the Visit button.",
    "Not Found Route: Redirects users to a Not Found page for invalid URLs or random paths.",
    "Header Navigation: Clicking the website logo redirects users to the Home page. // Provides direct navigation links to the Home and Jobs routes. // Implements a Logout button that redirects the user back to the Login page.",
    "Dynamic Filtering: Includes employmentTypesList and salaryRangesList data structures to filter jobs by employment type and salary range dynamically.",
    "Role: Managing and updating the application regularly to ensure seamless functionality, data integrity, and user engagement.",
    "Technologies used: React.js, API Integration, JWT Authentication, RESTful APIs, HTML, CSS, JavaScript.",
    "Username:-rahul, Password:- rahul@2021",
  ],
};

const Projects = () => {
  return (
    <div>
      <Title title="Recent" subTitle="Projects" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <ProjectsCard
            title="Nxt Trends ( Amazon, Flipkart )"
            category="E-commerce Clone"
            description="Created a modern e-commerce experience with a design inspired by Amazon and Flipkart."
            productOverview={ProductUlElements.NxtTrends}
            image={workImgThree}
            projectLink="https://gkflipcart.ccbp.tech/"
          />
          <ProjectsCard
            title="Food Munch"
            category="Food Store"
            description="Developed a responsive website for Food Store where users can see a list of food items, detailed information about a food item, offers"
            productOverview={ProductUlElements.FoodMunch}
            projectLink="https://kalyanresturant.ccbp.tech/"
            image={workImgTwo}
          />
          <ProjectsCard
            title="Wikipedia Search Application"
            category="Search Application"
            description="A custom Wikipedia search application that provides a simplified and intuitive way for users to access and view relevant information. With the ability to easily search for and view curated results, users can dive deeper into their interests with just a click."
            productOverview={ProductUlElements.WikiPeddia}
            projectLink="https://kalyanbrowser.ccbp.tech/"
            image={workImgFive}
          />
        </div>
        <div className="px-6">
          <ProjectsCard
            title="Todo Application"
            category="Todos"
            description="Developed persistent todo application with CRUD operations to track list of tasks"
            productOverview={ProductUlElements.TodoApplication}
            projectLink="https://gktodos.ccbp.tech/"
            image={workImgFour}
          />
          <ProjectsCard
            title="MCAConnectHub"
            category="React.js Web Application"
            description="MCAConnectHub is a user-friendly platform designed to assist students by providing essential academic resources and tools in one place."
            productOverview={ProductUlElements.MCAConnectHub}
            projectLink="https://mnp-one.vercel.app/"
            image={workImgSix}
          />
          <ProjectsCard
            title="Jobby App"
            category="Job Search Web Application"
            description="A comprehensive job search application built using modern web technologies, offering a smooth and interactive experience for authenticated users."
            productOverview={ProductUlElements.JobbyApp}
            projectLink="https://gkjob.ccbp.tech/"
            image={workImgEight}
          />
          {/* <ProjectsCard
            title="Test"
            category="Test"
            description="Created a modern e-commerce experience with a design inspired by Amazon and Flipkart."
            productOverview={ProductUlElements.NxtTrends}
            projectLink=""
            image={workImgSeven}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Projects;
